<script lang="ts">
  import aiIcon from '@/assets/ai-indicator.svg';

  import { markerColors } from '../config';
  import type { EditorMarking, EditorMarkings } from '../EditorMarkings.svelte';

  let {
    marking,
    markings,
  }: {
    marking: EditorMarking;
    markings: EditorMarkings;
  } = $props();
  const sidePadding = 2;
  const animate = marking.animate;
  let width = $state(0);
  const defaultColor = marking.type !== 'underline' ? marking.color : 'transparent';
  let backgroundColor = $state(defaultColor);
  let underlineColor = $state(
    marking.type === 'underline' ? marking.underlineColor || marking.color : 'transparent',
  );
  let focused = $state(false);
  let hovered = $state(false);
  let style = $derived(
    `
    top: ${getTop()}px;
    left: ${marking.rect.left - sidePadding}px; 
    width: ${width}px; 
    height: ${getHeight()}px; 
    background-color: ${backgroundColor}; 
    border-bottom: ${getBorder()};
    border-radius: ${getBorderRadius()};
    `,
  );

  let iconStyle = $derived(`
    top: ${marking.rect.top}px;
    left: 16px;
    z-index: 1;
  `);

  if (animate) {
    setTimeout(() => {
      width = marking.rect.width + 2 * sidePadding;
    }, 10);
  } else {
    width = marking.rect.width + 2 * sidePadding;
  }

  $effect(() => {
    updateColors(markings.hoveredMarkerId, markings.focusedMarkerIds, markings.editedMarkerIds);
  });

  function updateColors(hoveredId: string | undefined, focusedIds: string[], editedIds: string[]) {
    let bg;
    if (hoveredId === marking.markerId) {
      bg = marking.hoverColor || marking.color;
      focused = false;
      hovered = true;
    } else if (focusedIds.includes(marking.markerId)) {
      bg = marking.focusColor || marking.color;
      focused = true;
      hovered = false;
    } else {
      bg = defaultColor;
      focused = false;
      hovered = false;
    }
    if (editedIds.includes(marking.markerId)) {
      if (bg !== 'transparent') {
        bg = markerColors.neutral || defaultColor;
      }
      if (underlineColor !== 'transparent') {
        underlineColor = markerColors.sneutral || 'transparent';
      }
    }
    backgroundColor = bg ? bg : 'transparent';
  }

  function getTop() {
    return marking.rect.top;
  }

  function getHeight() {
    return marking.rect.height;
  }

  function getBorder() {
    if (marking.type === 'underline') {
      return `2px solid ${underlineColor}`;
    }
    return 'none';
  }

  function getBorderRadius() {
    if (marking.type === 'underline') {
      return '4px 4px 0 0';
    }
    return '4px';
  }
</script>

<div class="absolute w-0 transition-[width] duration-200" {style}></div>
{#if marking.icon && (focused || hovered)}
  <img class="absolute" style={iconStyle} src={aiIcon} alt="AI Icon" width="16" height="16" />
{/if}
